module.exports = __webpack_public_path__ + "a0a81017ec2b1560ba7f298fffea0f2a.png";